// Format helpers for QUILLA — Spanish/DO, USD, AST (UTC-4)

export function formatUSD(n) {
  if (n == null || isNaN(n)) return "US$0.00";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(n).replace("$", "US$");
}

export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  // Format as DD/MM/AAAA using AST (America/Santo_Domingo)
  const parts = new Intl.DateTimeFormat("es-DO", {
    timeZone: "America/Santo_Domingo",
    day: "2-digit", month: "2-digit", year: "numeric",
  }).formatToParts(d);
  const m = Object.fromEntries(parts.map(p => [p.type, p.value]));
  return `${m.day}/${m.month}/${m.year}`;
}

export function formatDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const parts = new Intl.DateTimeFormat("es-DO", {
    timeZone: "America/Santo_Domingo",
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false,
  }).formatToParts(d);
  const m = Object.fromEntries(parts.map(p => [p.type, p.value]));
  return `${m.day}/${m.month}/${m.year} ${m.hour}:${m.minute}`;
}

export function daysBetween(iso) {
  if (!iso) return 0;
  const ms = Date.now() - new Date(iso).getTime();
  return Math.max(0, Math.floor(ms / 86400000));
}

// Client-side image compression to reduce upload size on slow hotel WiFi.
// Downscales to max 1600px on the long side and re-encodes to JPEG q=0.75.
// Returns a File. Falls back to original if browser lacks support.
export async function compressImage(file, maxDim = 1600, quality = 0.75) {
  if (!file || !file.type?.startsWith("image/")) return file;
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, maxDim / Math.max(bitmap.width, bitmap.height));
    const w = Math.round(bitmap.width * scale);
    const h = Math.round(bitmap.height * scale);
    const canvas = document.createElement("canvas");
    canvas.width = w; canvas.height = h;
    canvas.getContext("2d").drawImage(bitmap, 0, 0, w, h);
    const blob = await new Promise(res => canvas.toBlob(res, "image/jpeg", quality));
    if (!blob) return file;
    return new File([blob], (file.name || "foto").replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg" });
  } catch (e) {
    // fallback silencioso: subimos el archivo original si el navegador falla en la compresión
    return file;
  }
}
